import { Box } from "@mui/material";
import MyNavbar from "./components/MyNavbar";
import HeroSection from "./components/HeroSection";
import FeatureSection from "./components/FeatureSection";
import Footer from "./components/Footer";

const Home = () => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        minHeight: "100vh",
        bgcolor: "background.default",
      }}
    >
      <MyNavbar />
      <HeroSection />
      <FeatureSection />
      <Footer />
    </Box>
  );
};

export default Home;